import { Service } from './service'
import request from '@js/builders/request_builder/index'
import store from '@vuex'

export class PairsService extends Service {
  /**
   * Loads all asset pairs existing in the system
   *
   *  @return {array} Asset pairs
   */
  loadAssetPairs () {
    return this._horizonRequestBuilder.assetPairs()
      .callWithSignature(this._keypair)
  }

  /**
   * getPrices
   *
   * @param source - base asset code to be converted
   * @param precision - prices precision, optional
   *  @return {array} of {"base": "source", "quote": "QUOTE", "price": "1.00000"}
   */
  getPrices ({source, precision}) {
    return request.exchange()
      .forCode(source, precision)
      .sign(store.getters.accountKeypair)
      .get()
      .then(
        resp => {
          const data = resp._rawResponse.data
          return data === null ? [] : data
        }
      )
  }

  /**
   * Loads all short asset pairs existing in the system
   *
   *  @return {array} Asset pairs
   */
  loadAssetPairsShort (currentToken) {
    return this._horizonRequestBuilder.assetPairsShort()
      .assetToken(currentToken)
      .call()
  }

  /**
   * Synchronously converts amount from one token to another
   *
   * @param amount - amount to be converted
   * @param sourceToken - token from which we're converting
   * @param destToken - token to which we're converting
   *
   * @return {string} Converted amount
   */
  loadConvertedAmount (amount, sourceToken, destToken) {
    return request.exchange()
      .convert(amount, sourceToken, destToken)
      .get()
      .then(
        resp => resp.data().amount
      )
  }

  /**
   * Asynchronously converts amount from one token to another
   *
   * @param amount - amount to be converted
   * @param sourceToken - token from which we're converting
   * @param destToken - token to which we're converting
   *
   * @return {string} Converted amount
   */
  loadConvertedAmountShort (amount, sourceToken, destToken) {
    return this._horizonRequestBuilder.assetPairsShort()
      .convert(amount, sourceToken, destToken)
      .call()
      .then(response => response.amount)
  }
  getOrder (from, to) {
    return request.exchange()
      .order(from, to)
      .sign(this._keypair)
      .json()
      .post()
      .then(resp => resp.data())
  }
}

export const pairsService = new PairsService()



// WEBPACK FOOTER //
// ./src/js/services/pairs.service.js